'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMzAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.88109e-06 0C9.33334 0 18.6667 -8.3689e-05 28 8.88109e-06V20C18.6667 20 9.33333 20 0 20C0 13.3333 -5.72404e-05 6.66667 8.88109e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V14.6667H0V20Z",
          fill: "#FFE547"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 5.33333H28V8.88109e-06L8.88109e-06 0L0 5.33333Z",
          fill: "#118C81"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 14.6667H28V5.33333H0V14.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 13.3333H28V6.66667H0V13.3333Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.88109e-06 0L13.3333 10L0 20L8.88109e-06 0Z",
          fill: "#EF2147"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66683 11.2741L2.70755 12.6967L3.45511 10.3937L1.49664 8.96996L3.91794 8.96927L4.66683 6.66669L5.41571 8.96927L7.83702 8.96996L5.87855 10.3937L6.62611 12.6967L4.66683 11.2741Z",
          fill: "#FDE444"
        }
      )
    ]
  }
);
const VpFlagMzAsset = forwardRef(FlagMzAsset);

export { VpFlagMzAsset as default };
